import { useEffect, useState } from "react";
import { MindfulnessCreate } from "./MindfulnessCreate";
import { useLoaderData, useParams } from "react-router-dom";

import { OpcionesEstadosTratamientos } from "../components/OpcionesEstadosTratamientos";

import * as APIUSER from "../services/user";

export function MindfulnessNew(props) {
  const mindfulness = useLoaderData();
  // const navigate = useNavigate();

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [isCreatingButton, setIsCreatingButton] = useState(false);

  // Set number of sesion based on number of items published
  let mindfulnessLength = mindfulness?.length ? mindfulness.length : 0;
  let currentSesion = mindfulnessLength + 1;

  const [mindResp, setMindResp] = useState(props.especialistaFullName);
  const [mindFecha, setMindFecha] = useState(todayDate);
  const [mindNumses, setMindNumses] = useState(currentSesion);
  const [mindObs, setMindObs] = useState("");
  const [mindMedio, setMindMedio] = useState("");
  const [mindTipo, setMindTipo] = useState("");
  const [mindPract, setMindPract] = useState("");
  const [mindPractEsp, setMindPractEsp] = useState("");
  const [mindPractSem, setMindPractSem] = useState("");
  const [mindPractTem, setMindPractTem] = useState("");
  const [mindEstado, setMindEstado] = useState("seguimiento");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitMindfulness = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      mindResp,
      mindFecha,
      mindNumses,
      mindObs,
      mindMedio,
      mindTipo,
      mindPract,
      mindPractEsp,
      mindPractSem,
      mindPractTem,
      mindEstado,
      tratamientoId,
      pacienteId
    );
    try {
      await MindfulnessCreate(
        mindResp,
        mindFecha,
        mindNumses,
        mindObs,
        mindMedio,
        mindTipo,
        mindPract,
        mindPractEsp,
        mindPractSem,
        mindPractTem,
        mindEstado,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../mindfulness/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        <form id="formNewElement" onSubmit={submitMindfulness}>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="mindResp">Responsable</label>
              <div className="control">
                <input
                  className="input"
                  id="mindResp"
                  required
                  type="text"
                  value={mindResp}
                  onChange={(e) => setMindResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="mindFecha">Fecha visita</label>
              <div className="control">
                <input
                  className="input"
                  id="mindFecha"
                  required
                  type="date"
                  value={mindFecha}
                  onChange={(e) => setMindFecha(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="mindNumses">Número de sesión</label>
              <div className="control">
                <input
                  className="input"
                  id="mindNumses"
                  required
                  disabled
                  type="number"
                  value={mindNumses}
                  onChange={(e) => setMindNumses(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="mindMedio">Medio</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="mindMedio"
                    required
                    name="mindMedio"
                    defaultValue=""
                    onChange={(e) => setMindMedio(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="presencial">Presencial</option>
                    <option value="videoconferencia">Videoconferencia</option>
                  </select>
                </div>
              </div>
            </div>

            {props.userRole.includes("administrador") && (
              <div className="field">
                <label htmlFor="mindEstado">Estado de seguimiento</label>
                <div className="control">
                  <div className="select">
                    <select
                      className="select"
                      id="mindEstado"
                      name="mindEstado"
                      value={mindEstado}
                      onChange={(e) => setMindEstado(e.target.value)}
                    >
                      {OpcionesEstadosTratamientos.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                          disabled={option.disabled}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}

            <div className="field">
              <label htmlFor="mindTipo">Tipo</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="mindTipo"
                    required
                    name="mindTipo"
                    defaultValue="general"
                    onChange={(e) => setMindTipo(e.target.value)}
                  >
                    <option disabled value="">
                      -- Selecciona una opción --
                    </option>
                    <option value="general">General</option>
                    <option value="sueno">Sueño</option>
                  </select>
                </div>
              </div>
            </div>

            {currentSesion === 1 ? (
              <>
                <div className="field key" data-key={mindPract?.toString()}>
                  <label htmlFor="mindPract">
                    ¿Ha practicado o practica Mindfulness?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="mindPract"
                        required
                        name="mindPract"
                        defaultValue=""
                        onChange={(e) => setMindPract(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="si-pasado">Sí, en el pasado</option>
                        <option value="si-actualmente">Sí actualmente</option>
                        <option value="si-pasado-actualmente">
                          Sí, en el pasado y actualmente
                        </option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="mindPractEsp">Especificar frecuencia</label>
                  <div className="control">
                    <input
                      className="input"
                      id="mindPractEsp"
                      type="text"
                      value={mindPractEsp}
                      onChange={(e) => setMindPractEsp(e.target.value)}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="field">
                  <label htmlFor="mindPractSem">
                    ¿Cuántas veces ha practicado Mindfulness en la última
                    semana?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="mindPractSem"
                        required
                        name="mindPractSem"
                        defaultValue=""
                        onChange={(e) => setMindPractSem(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="nada">Nada</option>
                        <option value="1-2">1-2 veces</option>
                        <option value="3-4">3-4 veces</option>
                        <option value="5-7">5-7 veces</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="mindPractTem">
                    ¿Cuánto tiempo ha practicado Mindfulness cada vez en la
                    última semana?
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      name="mindPractTem"
                      id="mindPractTem"
                      value={mindPractTem}
                      onChange={(e) => setMindPractTem(e.target.value)}
                    ></input>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="field">
            <label className="" htmlFor="mindObs">
              Observaciones
            </label>
            <div className="control">
              <textarea
                className="textarea"
                name="mindObs"
                id="mindObs"
                value={mindObs}
                onChange={(e) => setMindObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id="actions">
        <button
          className="button is-link"
          form="formNewElement"
          type="submit"
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      </div>
    </>
  );
}
